import React from "react";

import { connect } from "react-redux";
import {
  signInWithEmailAndPassword,
  signInWithGoogle,
  sendWhatsAppOTPForLogin,
  clearTwilioRateLimitForPhone,
  clearAllLockoutsForUser,
  checkOTPLockoutStatusByEmail
} from "../../store/actions/authActions";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Input from "@material-ui/core/Input";
import { Link } from "react-router-dom";
import InputLabel from "@material-ui/core/InputLabel";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Avatar from "@material-ui/core/Avatar";
import { grey } from "@material-ui/core/colors";
// Custom Components
import Companylogo from "../../components/layout/Companylogo";
import googleLogo from "../../assets/images/google-plus.svg";
import classNames from "classnames";
import { LIGHTBLUE, HOVERBLUE } from "../../utils/color_utils";
import { APP_TYPE } from "../../store/actions/types";
import {
  HOVERMAROON,
  GLPMAROON,
  RED,
  MAROONHOVER
} from "../../utils/color_utils";
import { app_config } from "../../constants";
import { SHOW_TOAST } from "../../store/actions/types";

const styles = theme => ({
  main: {
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  authCardHeading: {
    margin: "10px 15px 0"
  },
  authCardTitle: {
    textTransform: "uppercase",
    fontWeight: "bold",
    margin: theme.spacing.unit
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
      .spacing.unit * 3}px`,
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(320 + theme.spacing.unit * 3 * 2)]: {
      width: 320,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: 5
  },
  submitButton: {
    minWidth: "205px",
    padding: "10px 0px",
    marginTop: theme.spacing.unit,
    color: "#ffffff",
    backgroundColor: GLPMAROON,
    borderRadius: 10,
    "&:hover": {
      backgroundColor: HOVERMAROON
    }

    //'#d51317'  -- Red
  },
  submitGoogle: {
    minWidth: "205px",
    padding: "10px 0px",
    backgroundColor: RED,
    borderRadius: 10,
    "&:hover": {
      backgroundColor: MAROONHOVER
    },
    margin: `${theme.spacing.unit}px 0px`
  },
  button: {
    margin: `${theme.spacing.unit}px 0px`,
    color: LIGHTBLUE
  },

  smallButton: {
    margin: "10px 4px",
    backgroundColor: GLPMAROON,
    color: "#ffffff",
    borderRadius: 10,
    "&:hover": {
      backgroundColor: HOVERMAROON
    }
  },
  avatar: {
    marginRight: 10,
    width: 30,
    height: 30
  },
  formTextControl: {
    color: grey[700],
    fontSize: "0.875rem"
  },
  version: {
    fontSize: "8px",
    color: "#C0C0C0"
  }
});

function AuthCardHeader(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.authCardHeading)}>
      <Companylogo />
      <Typography
        className={classNames(classes.authCardTitle)}
        component="h6"
        variant="body2"
        align="center"
      >
        Leadership Platform
      </Typography>
    </div>
  );
}

class SignIn extends React.Component {
  state = {
    email: "",
    password: "",
    otp: "",
    showPassword: false,
    showOtpField: false,
    otpSent: false,
    otpMethod: "",
    phoneNumber: "",
    isLocked: false,
    lockoutMinutes: 0,
    failedAttempts: 0,
    remainingAttempts: 3,
    isRateLimited: false,
    rateLimitMessage: "",
    lockoutReason: "",
    developmentBypass: false,
    isVerifying: false
  };

  handleChange = prop => event => {
    this.setState({
      [prop]: event.target.value
    });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  resendOTP = () => {
    // Resend WhatsApp OTP
    if (this.state.phoneNumber) {
      this.props.sendWhatsAppOTPForLogin(this.state.phoneNumber).then((result) => {
        if (result && result.success) {
          this.setState({ otpSent: true });
        }
      });
    } else {
      // If no phone number stored, try to get it again
      this.props.signInEmail({
        email: this.state.email,
        password: this.state.password
      }).then(result => {
        if (result && result.phoneNumber) {
          this.setState({ phoneNumber: result.phoneNumber });
        }
      });
    }
  };

  goBackToLogin = () => {
    this.setState({
      showOtpField: false,
      otpSent: false,
      otp: ""
    });
  };

  handleVerifyOTP = async () => {
    this.setState({ isVerifying: true });
    
    try {
      // Check for development bypass
      if (this.state.developmentBypass && process.env.NODE_ENV === 'development') {
        // Development bypass - use a test OTP
        if (this.state.otp === '123456' || this.state.otp === '1234') {
          // Complete login directly
          const tempCredentials = JSON.parse(sessionStorage.getItem('tempLoginCredentials') || '{}');
          
          const result = await this.props.signInWithEmailAndPassword({
            email: tempCredentials.email,
            password: tempCredentials.password,
            otp: this.state.otp,
            bypassVerification: true // Flag for development bypass
          });
          
          if (result && result.success) {
            this.setState({
              showOtpField: false,
              otpSent: false,
              isVerifying: false,
              developmentBypass: false
            });
          } else {
            throw new Error('Development bypass failed');
          }
          return;
        } else {
          throw new Error('For development bypass, use OTP: 123456 or 1234');
        }
      }
      
      // Normal OTP verification
      const result = await this.props.signInWithEmailAndPassword({
        email: this.state.email,
        password: this.state.password,
        otp: this.state.otp
      });
      
      if (result && !result.success) {
        if (result.isLocked) {
          // User got locked out
          this.setState({
            isLocked: true,
            lockoutMinutes: result.remainingMinutes || 30,
            otp: "", // Clear OTP field
            lockoutReason: result.lockoutReason || 'OTP_VERIFICATION_FAILED'
          });
          this.startLockoutTimer();
        } else if (result.failedAttempts) {
          // Update failed attempts count
          this.setState({
            failedAttempts: result.failedAttempts,
            remainingAttempts: result.remainingAttempts || 0,
            otp: "", // Clear OTP field for retry
            lockoutReason: result.lockoutReason || 'OTP_VERIFICATION_FAILED'
          });
        }
      }
    } catch (error) {
      
      this.setState({
        isRateLimited: true,
        rateLimitMessage: "An error occurred. Please try again later.",
        showOtpField: false,
        otpSent: false
      });
    } finally {
      this.setState({ isVerifying: false });
    }
  };

  SignInWithEmail = async (e) => {
    e.preventDefault();

    // Require basic credentials
    if (!this.state.email || !this.state.password) {
      return;
    }

    // Preserve existing domain redirect behaviour
    this.checkUserDomain(this.state.email);

    // Direct email/password login with no WhatsApp OTP step
    try {
      await this.props.signInEmail({
        email: this.state.email,
        password: this.state.password,
        skipOTP: true
      });
    } catch (error) {
      // Errors are handled via toasts in authActions
    }
  };

  // Start countdown timer for lockout
  startLockoutTimer = () => {
    // Clear any existing timer first
    if (this.lockoutTimer) {
      clearInterval(this.lockoutTimer);
    }
    
    
    
    this.lockoutTimer = setInterval(() => {
      this.setState(prevState => {
        // Only proceed if we're still locked out
        if (!prevState.isLocked) {
          
          clearInterval(this.lockoutTimer);
          return prevState; // No state change
        }
        
        const newMinutes = prevState.lockoutMinutes - 1;
        
        
        if (newMinutes <= 0) {
          // Lockout expired
          
          clearInterval(this.lockoutTimer);
          this.lockoutTimer = null;
          return {
            ...prevState,
            isLocked: false,
            lockoutMinutes: 0,
            failedAttempts: 0,
            remainingAttempts: 3,
            lockoutReason: ""
          };
        }
        
        return {
          ...prevState,
          lockoutMinutes: newMinutes
        };
      });
    }, 60000); // Update every minute
  };

  componentWillUnmount() {
    if (this.lockoutTimer) {
      clearInterval(this.lockoutTimer);
    }
  }

  signInWithGoogle = e => {
    e.preventDefault();
    // No pre-check required. We rely on post-Google popup checks to allow/deny login.
    this.props.signInGoogle();
  };

  checkUserDomain = usr => {
    var url = window.location.origin;

    var corporates = [
      "edcon.co.za",
      "edcon@",
      "oneconnect.co.za",
      "oneconnect@",
      "harmony@",
      "harmony"
    ];

    for (var x = 0; x < corporates.length; x++) {
      var y = corporates[x];
      var patt = new RegExp(y);

      if (patt.test(usr)) {
        var corporateDomains = {
          "oneconnect.co.za": "https://oneconnect.thinklead.co.za",
          "oneconnect@": "https://oneconnect.thinklead.co.za",
          "edcon.co.za": "https://edcon.thinklead.co.za",
          "edcon@": "https://edcon.thinklead.co.za",
          "harmony@": "https://harmony.thinklead.co.za",
          "harmony": "https://harmony.thinklead.co.za"
        };

        var companyurl = corporateDomains[y];

        if (url !== companyurl) {
          window.location.replace(companyurl);
        }
      }
    }
  };

  clearRateLimit = () => {
    if (this.state.phoneNumber) {
      this.props.clearTwilioRateLimit(this.state.phoneNumber).then(result => {
        if (result && result.success) {
          // Reset rate limit state
          this.setState({
            isRateLimited: false,
            rateLimitMessage: ""
          });
        }
      });
    } else {
      // If no phone number, try with a dummy or the email domain
      var dummyPhone = "+27123456789"; // You can make this dynamic
      this.props.clearTwilioRateLimit(dummyPhone).then(result => {
        if (result && result.success) {
          this.setState({
            isRateLimited: false,
            rateLimitMessage: ""
          });
        }
      });
    }
  };

  resetEverything = () => {
    // Check if email is entered, as it's needed to identify the user
    if (!this.state.email) {
      this.props.showToast('warning', 'Please enter an email address to identify the user for lockout clearing.');
      return;
    }

    this.props.clearAllLockouts(this.state.email).then(result => {
      if (result && result.success) {
        this.setState({
          showOtpField: false,
          otpSent: false,
          otp: "",
          isLocked: false,
          lockoutMinutes: 0,
          failedAttempts: 0,
          remainingAttempts: 3,
          isRateLimited: false,
          rateLimitMessage: "",
          lockoutReason: "",
          developmentBypass: false,
          phoneNumber: result.phoneNumber || ""
        });
        
        if (this.lockoutTimer) {
          clearInterval(this.lockoutTimer);
          this.lockoutTimer = null;
        }
        // Show success toast
        this.props.showToast('success', result.message || 'All lockouts have been successfully cleared!');
      } else {
        // Show error toast if the clearing operation reported failure
        this.props.showToast('error', (result && result.error) || 'Failed to clear lockouts. Please check console for details.');
      }
    }).catch(error => {
      
      // Show error toast for unexpected errors
      this.props.showToast('error', 'An unexpected error occurred while clearing lockouts. Please try again.');
    });
  };

  getLockoutMessage = () => {
    switch (this.state.lockoutReason) {
      case 'OTP_VERIFICATION_FAILED':
        return `Account locked due to ${this.state.failedAttempts || 3} failed WhatsApp OTP verification attempts. This is a security measure to protect your account.`;
      case 'RATE_LIMITED':
        return 'Too many verification requests. Twilio rate limit exceeded.';
      case 'PASSWORD_FAILED':
        return 'Account locked due to multiple incorrect password attempts.';
      case 'UNKNOWN':
      default:
        return 'Account locked due to multiple failed login attempts. Please contact support if this continues.';
    }
  };

  componentDidMount() {
    // Check for existing test lockout in localStorage
    const testLockout = localStorage.getItem('testLockout');
    if (testLockout) {
      try {
        const lockoutData = JSON.parse(testLockout);
        const now = Date.now();
        const elapsed = Math.floor((now - lockoutData.timestamp) / (1000 * 60)); // minutes elapsed
        const remaining = Math.max(0, lockoutData.lockoutMinutes - elapsed);
        
        if (remaining > 0) {
          this.setState({
            isLocked: true,
            lockoutMinutes: remaining,
            failedAttempts: 3,
            remainingAttempts: 0,
            lockoutReason: 'OTP_VERIFICATION_FAILED',
            showOtpField: false,
            otpSent: false,
            isRateLimited: false
          });
          this.startLockoutTimer();
        } else {
          // Lockout expired, clear it
          localStorage.removeItem('testLockout');
        }
      } catch (e) {
        localStorage.removeItem('testLockout');
      }
    }
    
    // Add testing function to window for console access
    window.testLockout = () => {
      this.setState({
        isLocked: true,
        lockoutMinutes: 25, // Example: 25 minutes remaining
        failedAttempts: 3,
        remainingAttempts: 0,
        lockoutReason: 'OTP_VERIFICATION_FAILED'
      });
      this.startLockoutTimer();
    };
    
    // Add clear lockout function
    window.clearTestLockout = () => {
      this.setState({
        isLocked: false,
        lockoutMinutes: 0,
        failedAttempts: 0,
        remainingAttempts: 3,
        lockoutReason: ''
      });
      if (this.lockoutTimer) {
        clearInterval(this.lockoutTimer);
      }
      localStorage.removeItem('testLockout');
    };
  }

  render() {
    const { classes } = this.props;

    return (
      <main className={classes.main}>
        <CssBaseline />
        
        {/* FLOATING RESET BUTTON - Top right corner */}
        <div style={{
          position: 'fixed',
          top: '20px',
          right: '20px',
          zIndex: 9999
        }}>
          <button
            onClick={this.resetEverything}
            style={{
              backgroundColor: '#ff5722',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '10px 15px',
              fontSize: '12px',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}
          >
            🔧 RESET ALL
          </button>
        </div>
        
        <Paper className={classes.paper}>
          <AuthCardHeader {...this.props} />
          
          <form className={classes.form} onSubmit={this.SignInWithEmail} noValidate>
            
            {/* TEST BUTTON - Should always be visible */}
            <Button
              variant="contained"
              fullWidth
              style={{ 
                backgroundColor: '#ff0000',
                color: 'white',
                marginBottom: '10px',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
              onClick={() => alert('TEST BUTTON WORKS!')}
            >
              🚨 TEST - CLICK ME
            </Button>
            
            {/* Rate Limit Warning */}
            {this.state.isRateLimited && (
              <div style={{ 
                backgroundColor: '#fff3e0', 
                padding: '16px', 
                borderRadius: '8px', 
                marginBottom: '16px',
                border: '2px solid #ff9800'
              }}>
                <Typography variant="h6" style={{ color: '#f57c00', fontWeight: 'bold', marginBottom: '8px' }}>
                  ⚠️ Too Many Verification Attempts
                </Typography>
                <Typography variant="body2" style={{ color: '#f57c00', marginBottom: '12px' }}>
                  {this.state.rateLimitMessage}
                </Typography>
                <Typography variant="caption" style={{ color: '#f57c00', fontSize: '12px' }}>
                  This is a security measure. The system will automatically reset after 10 minutes.
                </Typography>
                {process.env.NODE_ENV === 'development' && (
                  <div style={{ marginTop: '12px' }}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="secondary"
                      onClick={this.clearRateLimit}
                      style={{ fontSize: '11px' }}
                    >
                      🔧 Clear Rate Limit (Dev Only)
                    </Button>
                  </div>
                )}
              </div>
            )}

            {/* Lockout Warning */}
            {this.state.isLocked && !this.state.isRateLimited && (
              <div style={{ 
                backgroundColor: '#f44336',  // Bright red background
                color: 'white',
                padding: '20px', 
                borderRadius: '8px', 
                marginBottom: '20px',
                border: '3px solid #d32f2f',
                textAlign: 'center',
                boxShadow: '0 4px 8px rgba(0,0,0,0.3)'
              }}>
                <Typography variant="h5" style={{ color: 'white', fontWeight: 'bold', marginBottom: '10px' }}>
                  🔒 ACCOUNT LOCKED FOR 30 MINUTES
                </Typography>
                <Typography variant="h6" style={{ color: 'white', marginBottom: '10px' }}>
                  ⏰ TIME REMAINING: {this.state.lockoutMinutes} MINUTE{this.state.lockoutMinutes !== 1 ? 'S' : ''}
                </Typography>
                <Typography variant="body1" style={{ color: 'white', marginBottom: '8px' }}>
                  {this.getLockoutMessage()}
                </Typography>
                <Typography variant="body2" style={{ color: 'white', fontSize: '14px' }}>
                  This is a security measure to protect your account from unauthorized access.
                </Typography>
                <Typography variant="caption" style={{ color: 'white', fontSize: '12px', marginTop: '8px', display: 'block' }}>
                  The lockout will automatically expire and you can try again.
                </Typography>
              </div>
            )}

            {/* Failed attempts warning */}
            {!this.state.isLocked && this.state.failedAttempts > 0 && this.state.showOtpField && (
              <div style={{ 
                backgroundColor: '#fff3e0', 
                padding: '10px', 
                borderRadius: '4px', 
                marginBottom: '12px',
                border: '1px solid #ff9800'
              }}>
                <Typography variant="caption" style={{ color: '#f57c00' }}>
                  ⚠️ {this.state.remainingAttempts} attempt{this.state.remainingAttempts !== 1 ? 's' : ''} remaining before 30-minute lockout
                </Typography>
              </div>
            )}
            
            <FormControl margin="dense" required fullWidth>
              <InputLabel htmlFor="email">Email Address</InputLabel>
              <Input
                id="email"
                name="email"
                value={this.state.email}
                onChange={this.handleChange("email")}
                disabled={this.state.isLocked || this.state.isRateLimited}
              />
            </FormControl>
            <FormControl margin="dense" required fullWidth>
              <InputLabel htmlFor="adornment-password">Password</InputLabel>
              <Input
                id="adornment-password"
                type={this.state.showPassword ? "text" : "password"}
                value={this.state.password}
                onChange={this.handleChange("password")}
                disabled={this.state.isLocked || this.state.isRateLimited}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={this.handleClickShowPassword}
                      disabled={this.state.isLocked || this.state.isRateLimited}
                    >
                      {this.state.showPassword ? (
                        <Visibility />
                      ) : (
                        <VisibilityOff />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>

            {this.state.showOtpField && !this.state.isRateLimited && (
              <FormControl margin="dense" required fullWidth>
                <InputLabel htmlFor="otp">
                  📱 WhatsApp OTP
                </InputLabel>
                <Input
                  id="otp"
                  name="otp"
                  value={this.state.otp}
                  placeholder="Enter 6-digit WhatsApp OTP"
                  onChange={this.handleChange("otp")}
                  disabled={this.state.isLocked}
                  autoFocus={!this.state.isLocked}
                  inputProps={{
                    maxLength: 6,
                    pattern: "[0-9]*",
                    inputMode: "numeric",
                    style: { textAlign: 'center', fontSize: '18px', letterSpacing: '2px' }
                  }}
                />
                {this.state.otpSent && !this.state.isLocked && (
                  <div style={{ marginTop: '5px' }}>
                    <Typography variant="caption" style={{ color: '#4caf50' }}>
                      OTP sent to your WhatsApp number
                    </Typography>
                    <Button
                      size="small"
                      color="primary"
                      onClick={this.resendOTP}
                      disabled={this.state.isLocked}
                      style={{ marginLeft: '10px', textTransform: 'none', fontSize: '12px' }}
                    >
                      Resend OTP
                    </Button>
                  </div>
                )}
                {this.state.developmentBypass && process.env.NODE_ENV === 'development' && (
                  <div style={{
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffeaa7', 
                    borderRadius: '4px',
                    padding: '12px',
                    marginTop: '10px',
                    color: '#856404',
                    textAlign: 'center',
                    fontSize: '14px'
                  }}>
                    <strong>🔧 Development Mode:</strong><br/>
                    WhatsApp OTP service is unavailable.<br/>
                    Use OTP: <strong>123456</strong> or <strong>1234</strong> to bypass verification.
                  </div>
                )}
              </FormControl>
            )}

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              className={classes.submitButton}
              disabled={this.state.isLocked || this.state.isRateLimited}
              onClick={(e) => {
                // Check if Ctrl+Click or Alt+Click for force clear lockout
                if (e.ctrlKey || e.altKey) {
                  e.preventDefault();
                  if (this.state.email) {
                    this.props.clearAllLockouts(this.state.email).then(result => {
                      if (result && result.success) {
                        // Reset local state
                        this.setState({
                          isLocked: false,
                          lockoutMinutes: 0,
                          failedAttempts: 0,
                          remainingAttempts: 3,
                          lockoutReason: '',
                          showOtpField: false,
                          otpSent: false,
                          isRateLimited: false,
                          rateLimitMessage: ""
                        });
                        
                        // Clear any running timers
                        if (this.lockoutTimer) {
                          clearInterval(this.lockoutTimer);
                        }
                      }
                    });
                  } else {
                    alert('Please enter an email address first');
                  }
                } else {
                  // Normal login
                  this.SignInWithEmail(e);
                }
              }}
              style={{
                backgroundColor: (this.state.isLocked || this.state.isRateLimited) ? '#ccc' : undefined,
                opacity: (this.state.isLocked || this.state.isRateLimited) ? 0.6 : 1
              }}
              title="Ctrl+Click to force clear lockout"
            >
              {this.state.isRateLimited
                ? "RATE LIMITED - WAIT 10 MINUTES (Ctrl+Click to Clear)"
                : this.state.isLocked 
                  ? `LOCKED (${this.state.lockoutMinutes}m) - Ctrl+Click to Force Clear` 
                  : this.state.showOtpField 
                    ? "VERIFY OTP (Ctrl+Click to Clear Lockout)" 
                    : "LOGIN (Ctrl+Click to Clear Lockout)"
              }
            </Button>

            {/* DEVELOPMENT RESET BUTTON - Always visible for testing */}
            <Button
              type="button"
              variant="contained"
              fullWidth
              onClick={this.resetEverything}
              style={{ 
                marginTop: '10px', 
                fontSize: '14px',
                backgroundColor: '#ff5722',
                color: 'white',
                fontWeight: 'bold'
              }}
            >
              🔧 RESET EVERYTHING (Clear All Lockouts)
            </Button>

            {/* Temporary Rate Limit Clear Button (for development) */}
            {process.env.NODE_ENV === 'development' && this.state.phoneNumber && (
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                fullWidth
                onClick={this.clearRateLimit}
                style={{ marginTop: '10px', fontSize: '12px' }}
              >
                🔧 Clear Rate Limit (Dev)
              </Button>
            )}

            {APP_TYPE === "PUBLIC" ? (
              <div>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    className={classes.submitGoogle}
                    onClick={this.signInWithGoogle}
                    style={{ flex: 1 }}
                  >
                    <Avatar
                      alt="Google Logo"
                      src={googleLogo}
                      className={classes.avatar}
                    />
                    Sign In With Google
                  </Button>
                </div>
                
                <FormControlLabel
                  value="start"
                  classes={{ label: classes.formTextControl }}
                  control={
                    <Button
                      size="small"
                      variant="contained"
                      className={classes.smallButton}
                      component={Link}
                      to="/signup"
                    >
                      Sign up
                    </Button>
                  }
                  label="You dont have an account?"
                  labelPlacement="start"
                />
              </div>
            ) : null}

            <Button
              component={Link}
              color="primary"
              disableRipple={true}
              disableFocusRipple={true}
              to="/reset-password"
              className={classes.button}
              fullWidth
            >
              Forgot Password
            </Button>
          </form>
          <span className={classes.version}>Version {app_config.version}</span>
        </Paper>
      </main>
    );
  }
}

const SignInModule = withStyles(styles)(SignIn);

const mapDispatchToProps = dispatch => {
  return {
    signInEmail: (creds) => {
      return dispatch(signInWithEmailAndPassword(creds)).then(result => {
        return result;
      });
    },
    signInGoogle: () => dispatch(signInWithGoogle()),
    sendWhatsAppOTPForLogin: phoneNumber => dispatch(sendWhatsAppOTPForLogin(phoneNumber)),
    clearTwilioRateLimit: phoneNumber => dispatch(clearTwilioRateLimitForPhone(phoneNumber)),
    clearAllLockouts: (email) => dispatch(clearAllLockoutsForUser(email)),
    checkOTPLockoutStatusByEmail: email => dispatch(checkOTPLockoutStatusByEmail(email)),
    showToast: (variant, message) => dispatch({ type: SHOW_TOAST, variant, message })
  };
};

export default connect(
  null,
  mapDispatchToProps
)(SignInModule);